<template>
    <div class="Shop">
        <menuBox :step="4"></menuBox>
        <div class="us-1">
            <div class="us-text-1">We Are The Best Agency!</div>
            <div class="us-text-2">Contact Us</div>
            <div class="us-text-3">EXTEND TECH PTE. LTD. is the best consectetuer adipiscing elit, sed diam nonum My nibh euismod tincidunt business agency.</div>
        </div>
        <div class="us-2">
            <img src="../assets/us-2.png" alt="">
            <div class="form-box">
                <!-- <div class="form-1">Contact Us</div> -->
                <div class="form-2">Contact Us</div>
                <div class="form-3">EXTEND TECH PTE. LTD. is the best consectetuer adipiscing elit, sed diam nonum My nibh euismod tincidunt business agency.</div>
                <input v-model="value1" class="form-4" type="text" placeholder="Telephone">
                <input v-model="value2" class="form-5" type="text" placeholder="Mail">
                <input v-model="value3" class="form-6" type="text" placeholder="Name">
                <textarea v-model="value4" class="form-7" name="" id="" cols="30" rows="10" placeholder="Message"></textarea>
                <div class="form-8" @click="sendValue">Send Message</div>
            </div>
        </div>
        <img src="../assets/us-3.png" class="us-3">

        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            value1: '',
            value2: '',
            value3: '',
            value4: '',
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        },
        sendValue() {
            if (!this.value1 || !this.value2 || !this.value3) {
                return alert('Data is empty')
            }
            alert('Submitted successfully')
        }
    }
}
</script>
<style lang="less" scoped>
.us-1 {
    height: 500px;
    background: url(../assets/us-1.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: self-start;
    justify-content: center;

    .us-text-1 {
        font-size: 16px;
        font-weight: 600;
        color: #3DA685;
        padding: 10px 28px;
        background: fade(#3DA685, 30%);
        margin-left: 300px;
    }

    .us-text-2 {
        font-size: 72px;
        font-weight: 600;
        color: #FFFFFF;
        margin-top: 13px;
        width: 550px;
        margin-left: 300px;
    }

    .us-text-3 {
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        margin-top: 8px;
        width: 550px;
        margin-left: 300px;
    }
}

.us-2 {
    padding: 120px 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
        width: 790px;
    }

    .form-box {
        width: 640px;
        height: 720px;
        background: #FFFFFF;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        display: flex;
        flex-direction: column;
        align-items: self-start;

        .form-1 {
            font-size: 16px;
            font-weight: 600;
            color: #3DA685;
            padding: 10px 28px;
            background: fade(#3DA685, 30%);
            margin-left: 40px;
            margin-top: 40px;
        }

        .form-2 {
            font-size: 48px;
            font-weight: 600;
            color: #333333;
            margin-left: 40px;
            margin-top: 40px;
        }

        .form-3 {
            width: 543px;
            font-size: 16px;
            font-weight: 600;
            color: #999999;
            margin-left: 40px;
            margin-top: 21px;
        }

        .form-4 {
            margin-left: 40px;
            margin-top: 40px;
        }

        .form-5 {
            margin-left: 40px;
            margin-top: 21px;
        }

        .form-6 {
            margin-left: 40px;
            margin-top: 21px;
        }

        .form-7 {
            margin-left: 40px;
            margin-top: 21px;
        }

        .form-8 {
            width: 240px;
            height: 71px;
            background: #3DA685;
            font-size: 20px;
            font-weight: 600;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 40px;
            margin-top: 21px;
            cursor: pointer;
        }
    }
}

.us-3 {
    width: 100%;
}
</style>
